import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Página no encontrada | Alfasol</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <h1>Página no encontrada</h1>
    </>
  );
}